import { apiService } from './apiService';

export const emptyReturnService = {
  async getResponsibles() {
    return apiService.get('/empty-returns/responsibles');
  },

  async getMyRecords() {
    return apiService.get('/empty-returns/my-records');
  },

  async start(responsibleUserId: string) {
    return apiService.post('/empty-returns/start', { responsibleUserId });
  },

  async finish(id: string) {
    return apiService.post(`/empty-returns/${id}/finish`, {});
  },
};
